module.exports = __webpack_public_path__ + "static/media/yasa-error-404.df94655e.png";